<script setup lang="ts">
import type { ExperimentKey } from '~/types/amplitude/types'

const props = withDefaults(
  defineProps<{
    flagKey?: ExperimentKey | ExperimentKey[]
  }>(),
  {
    flagKey: () => [],
  },
)

defineSlots<{ control(): any; treatment(): any }>()

const { isTreatment } = useExperiment(
  ...(Array.isArray(props.flagKey) ? props.flagKey : [props.flagKey]),
)
</script>

<template>
  <slot v-if="isTreatment" name="treatment" />
  <slot v-else name="control" />
</template>
